import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import get from "lodash/get";
import React from "react";
import { FormattedMessage } from "react-intl";
import { instance } from "../../../../Actions/AxiosInstance";
import { ValidateAction, ValidateReqField } from "../../../../Utils/Validation";
import createstore from "../../../../store";
import { getEJ2CalenderDateFormat } from "../../../../Utils";
import { DatePickerComponent } from "../../../../Component/Custom";

class EmpMedicalIssueForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      maxDate: new Date(),
      fields: {
        condition: "",
        conditionstartdate: "",
        conditionenddate: "",
        conditionname: "",
      },
      reqFields: {
        condition: "",
        conditionstartdate: "",
        conditionname: "",
      },
      errors: {},
      helperText: {},
      CommonError: "",
    };

    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    // CustomForm();
    if (get(this.firstElement, "onFocus", "")) this.firstElement.onFocus();
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    const { employeeid } = SubscriptionInfo.SubscriptionData;
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
      },
      () => {
        this.GetPerticularMedicalDetails();
      },
    );
  }

  GetPerticularMedicalDetails() {
    if (this.state.data) {
      const { data } = this.state;
      const fields = {
        employeemedicalconditionid: data.employeemedicalconditionid,
        condition: data.condition,
        conditionstartdate: data.conditionstartdate ? new Date(data.conditionstartdate) : "",
        conditionenddate: data.conditionenddate ? new Date(data.conditionenddate) : "",
        conditionname: data.conditionname,
      };
      const reqFields = {
        condition: data.condition,
        conditionstartdate: data.conditionenddate ? new Date(data.conditionenddate) : "",
      };
      this.setState({ fields, reqFields });
    }
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields });
    if (field === "conditionname") {
      this.ValidateField(field, type, e);
    }
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  convertDate(str) {
    // var date = new Date(str);
    // let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    // let day = ("0" + date.getDate()).slice(-2);
    // return [date.getFullYear(), mnth, day].join("-");
    // return str;
  }

  selectDate(a, args) {
    console.log("a, args: ", a, args);
    const { fields } = this.state;
    if (args.value) {
      // let date = this.convertDate(args.value)
      fields[a] = args.value;
    } else {
      fields[a] = null;
    }
    this.setState({ fields });
  }

  Validate() {
    let isValid = true;

    if (!this.state.fields.condition) {
      this.setState({ CommonError: "Please fill all the required fields" });
      return (isValid = false);
    }
    this.setState({ CommonError: "" });

    if (!this.state.fields.conditionstartdate) {
      this.setState({ CommonError: "Please select diagnosis date" });
      return (isValid = false);
    }
    this.setState({ CommonError: "" });

    if (this.state.errors.conditionname === true) {
      this.setState({ CommonError: "Please enter condition name" });
      return (isValid = false);
    }
    this.setState({ CommonError: "" });

    if (this.state.fields.conditionstartdate && this.state.fields.conditionenddate) {
      if (this.state.fields.conditionstartdate > this.state.fields.conditionenddate) {
        this.setState({ CommonError: "Treatment End date should be greater than diagnosis date" });
        return (isValid = false);
      }
      this.setState({ CommonError: "" });
    }

    return isValid;
  }

  AddMedicalIssue() {
    if (this.state.fields.conditionname == null || "") {
      this.props.enqueueSnackbar("Please add condition name", { variant: "error" });
    } else if (
      !this.state.fields.conditionstartdate
      || this.state.fields.conditionstartdate == "Invalid Date"
    ) {
      this.props.enqueueSnackbar("Please add Diagnosis date", { variant: "error" });
    } else if (!this.Validate()) {
      setTimeout(
        () => this.props.enqueueSnackbar(this.state.CommonError, { variant: "error" }),
        300,
      );
    } else {
      let { conditionstartdate } = this.state.fields;
      let { conditionenddate } = this.state.fields;
      if (conditionstartdate) {
        const startdate = new Date(conditionstartdate);
        const startmnth = `0${startdate.getMonth() + 1}`.slice(-2);
        const startday = `0${startdate.getDate()}`.slice(-2);
        conditionstartdate = [startdate.getFullYear(), startmnth, startday].join("-");
      }
      if (conditionenddate == "Invalid Date" || conditionenddate == null) {
        conditionenddate = "";
      } else {
        const enddate = new Date(conditionenddate);
        const endmnth = `0${enddate.getMonth() + 1}`.slice(-2);
        const endday = `0${enddate.getDate()}`.slice(-2);
        conditionenddate = enddate == "Invalid Date" || !enddate ? null : [enddate.getFullYear(), endmnth, endday].join("-");
      }

      let flag;
      this.state.fields.employeemedicalconditionid ? (flag = 3) : (flag = 2);
      const data = {
        employeemedicalconditionid: this.state.fields.employeemedicalconditionid,
        condition: this.state.fields.condition,
        conditionstartdate,
        conditionenddate,
        conditionname: this.state.fields.conditionname,
        employeeid: this.props.colleagueid || this.props.employeeid,
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
          employeeid: this.props.colleagueid || this.props.employeeid,
        });
      }
      instance
        .post("employee/insertupdateempmedical", data)
        .then(() => {
          this.props.enqueueSnackbar("Saved successfully", { variant: "success" });
          this.setState({
            condition: "",
            conditionstartdate: "",
            conditionenddate: "",
            employeemedicalconditionid: "",
            conditionname: "",
          });
          this.props.SetFlag(flag, true);
        })
        .catch((error) => {
          const CommonError = error.response ? error.response.data.error.message : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  onCancel() {
    this.props.SetFlag(3, true);
  }

  ValidateOnNext(reqField, type) {
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  render() {
    return (
      <div className="form-height">
        <div id="div">
          <form className="custom-form-box profile-medical" autoComplete="off">
            <div className="inner-wrapper margin-bottom-20" tabIndex="0">
              <p className="active-color">
                <FormattedMessage
                  id="LbMedicalHistory"
                  defaultMessage="Please mention your medical history"
                />
              </p>
              <p className="input-form-label">
                <FormattedMessage id="LbhealthAilment" defaultMessage="Health ailment name" />
              </p>
              <div>
                <TextField
                  ref={(r) => {
                    this.firstElement = r;
                  }}
                  autoFocus
                  id="outlined-dense"
                  style={{ width: 410 }}
                  variant="outlined"
                  placeholder="Your health issue"
                  onChange={this.OnFieldChange.bind(this, "condition", "name")}
                  onBlur={this.ValidateField.bind(this, "condition", "name")}
                  value={this.state.fields.condition}
                  maxLength="100"
                  className="expense-cycle-input healthAilment"
                />
              </div>
              {this.state.errors.condition ? (
                <span className="caption-error">Health ailment name is required</span>
              ) : (
                ""
              )}
            </div>
            <div className="inner-wrapper margin-bottom-20" tabIndex="1">
              <p className="input-form-label">
                <FormattedMessage id="Lbconditionname" defaultMessage="Condition name" />{" "}
              </p>
              <div>
                <TextField
                  id="outlined-dense"
                  style={{ width: 410 }}
                  variant="outlined"
                  placeholder="Your condition status"
                  onChange={this.OnFieldChange.bind(this, "conditionname", "name")}
                  value={this.state.fields.conditionname}
                  maxLength="100"
                  className="expense-cycle-input conditionname"
                />
              </div>
              {this.state.errors.condition ? (
                <span className="caption-error">Condition name is required</span>
              ) : (
                ""
              )}
            </div>
            <div className="inner-wrapper margin-bottom-20" tabIndex="2">
              <p className="active-color">
                <span className="emp-special-head active" />
                <span className="input-form-label">
                  <FormattedMessage id="LbStartDate" defaultMessage="Start date" />
                </span>
              </p>
              <DatePickerComponent
                className="selectsearch input-area-section conditionstartdate"
                placeholder="Start Date"
                format={getEJ2CalenderDateFormat()}
                id="conditionstartdate"
                start="Decade"
                allowEdit={true}
                // onClick={() => this.dateObj1.show()}
                // ref={(date)) => (this.dateObj1 = date)}
                max={this.state.maxDate}
                change={this.selectDate.bind(this, "conditionstartdate")}
                value={this.state.fields.conditionstartdate}
                width="410px"
                // onBlur={this.ValidateField.bind(this, "conditionstartdate", "date")}
              />
              {this.state.errors.conditionstartdate ? (
                <span className="caption-error">
                  <FormattedMessage id="Erconditionstartdate" defaultMessage="can not be empty" />
                </span>
              ) : (
                ""
              )}
            </div>
            <div className="inner-wrapper margin-bottom-20" tabIndex="3">
              <p className="active-color">
                <span className="input-form-label">
                  <FormattedMessage id="LbEndDate" defaultMessage="Treatment end date" />
                  &nbsp;
                  <FormattedMessage id="LbOptional" defaultMessage="(Optional)" />
                </span>
              </p>
              <DatePickerComponent
                className="selectsearch input-area-section conditionenddate"
                placeholder="End Date"
                start="Decade"
                format={getEJ2CalenderDateFormat()}
                id="conditionenddate"
                min={this.state.fields.conditionstartdate}
                allowEdit={true}
                // onClick={() => this.dateObj2.show()}
                // ref={(date)) => (this.dateObj2 = date)}
                change={this.selectDate.bind(this, "conditionenddate")}
                value={this.state.fields.conditionenddate}
                width="410px"
              />
            </div>
            <div className="upform-footer">
              <Button
                variant="contained"
                className="form-btn save"
                color="primary"
                size="large"
                onClick={this.AddMedicalIssue.bind(this)}
              >
                <FormattedMessage id="BtSave" defaultMessage="Save" />
              </Button>
              <span className="margin-left-16" />
              <Button size="large" onClick={this.onCancel} className="Cancel">
                <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
              </Button>
            </div>
          </form>
        </div>
      </div>

      // <div className='emp-from-wrapper imp-dates medial-issue-form'>

      // </div>
    );
  }
}

export default withSnackbar(EmpMedicalIssueForm);
